
    import { parse } from "@component/query-string";
    const { VITE_ENV, VITE_REGION } = import.meta.env;
    const { token } = parse(window.location.search);
    window.__TOKEN__ = token;
    window.__PINGPONG_CHECKOUT_INJECT_ENV__ = VITE_ENV;
    window.__PINGPONG_CHECKOUT_INJECT_REGION__ = VITE_REGION;

    // 动态加载 pp-checkout JS
    function loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.setAttribute('type', 'module');
        script.onload = resolve;
        script.onerror = reject;
        script.src = src;
        document.head.appendChild(script);
      });
    }

    // 加载 eruda 用于调试
    if (VITE_ENV !== 'PROD') {
      loadScript('https://cdn.jsdelivr.net/npm/eruda').then(() => {
        eruda.init();
      });
    }
  